import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { useCredits } from '../hooks/useCredits';
import { isNative } from '../lib/platform';

const PRODUCT_MESSAGES: Record<string, string> = {
  monthly_sub:    '✦ Assinatura mensal ativada! Bem-vindo ao Professya Pro.',
  annual_sub:     '✦ Assinatura anual ativada! Bem-vindo ao Professya Pro.',
  questions_q3:   '✦ 3 créditos de pergunta adicionados!',
  questions_q5:   '✦ 5 créditos de pergunta adicionados!',
  questions_q10:  '✦ 10 créditos de pergunta adicionados!',
  synastry_s1:    '✦ 1 crédito de sinastria adicionado!',
  synastry_s3:    '✦ 3 créditos de sinastria adicionados!',
  astromatch_a3:  '✦ 3 créditos de AstroMatch adicionados!',
  astromatch_a10: '✦ 10 créditos de AstroMatch adicionados!',
};

const PRODUCT_REDIRECT: Record<string, string> = {
  monthly_sub:    '/dashboard',
  annual_sub:     '/dashboard',
  questions_q3:   '/questions',
  questions_q5:   '/questions',
  questions_q10:  '/questions',
  synastry_s1:    '/synastry',
  synastry_s3:    '/synastry',
  astromatch_a3:  '/astromatch',
  astromatch_a10: '/astromatch',
};

export function CheckoutSuccessPage() {
  const [params]     = useSearchParams();
  const navigate     = useNavigate();
  const { refreshProfile } = useAuth();
  const { refresh }  = useCredits();
  const [seconds,    setSeconds]  = useState(5);
  const productId    = params.get('product') ?? '';
  const message      = PRODUCT_MESSAGES[productId] ?? '✦ Compra confirmada! Obrigado.';
  const redirectTo   = PRODUCT_REDIRECT[productId] ?? '/dashboard';

  useEffect(() => {
    // Refresh state immediately
    refreshProfile();
    refresh();

    if (isNative) {
      // On native, just show toast and don't redirect
      return;
    }

    const timer = setInterval(() => {
      setSeconds(s => {
        if (s <= 1) {
          clearInterval(timer);
          navigate(redirectTo, { replace: true });
          return 0;
        }
        return s - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: 'var(--bg-base)', padding: '1.5rem' }}>
      <div style={{ textAlign: 'center', maxWidth: '380px', width: '100%' }}>
        <span style={{ fontSize: '4rem', display: 'block', marginBottom: '1.5rem' }}>🌟</span>
        <h1 className="font-display" style={{ fontSize: 'clamp(1.25rem,4vw,1.75rem)', color: 'var(--text-primary)', marginBottom: '1rem' }}>
          {message}
        </h1>
        <p style={{ color: 'var(--text-secondary)', fontSize: 'var(--text-label)', lineHeight: 1.6, marginBottom: '2rem' }}>
          Seu pagamento foi confirmado. Os astros agradecem por confiar em sua jornada ✦
        </p>

        {!isNative && (
          <p style={{ color: 'var(--text-muted)', fontSize: 'var(--text-caption)', marginBottom: '1.5rem' }}>
            Redirecionando em {seconds} segundo{seconds !== 1 ? 's' : ''}...
          </p>
        )}

        <button className="btn btn-primary" onClick={() => navigate(redirectTo, { replace: true })}>
          Continuar ✦
        </button>
      </div>
    </div>
  );
}
